import React from 'react';
import { Layout } from 'antd';

const { Footer: AntFooter } = Layout;

const Footer = ({ whiteText }) => {
 return (
   <AntFooter style={{ 
     textAlign: 'center', 
     background: 'transparent',
     padding: '12px 50px',
     color: whiteText ? 'white' : 'inherit',
     cursor: 'pointer'
   }}
   onClick={() => window.open('https://alfama.com.br/', '_blank')}
   >
     © {new Date().getFullYear()} Alfama Foods. Todos os direitos reservados.
   </AntFooter>
 );
};

export default Footer;